export const SET_DATE = "TELEMATICS_AGGREGATIONS/SET_DATE";
export const SET_UNAPPROVED_RIDES_FILTER =
  "TELEMATICS_AGGREGATIONS/SET_UNAPPROVED_RIDES_FILTER";
export const FETCH_AGGREGATED_DRIVES =
  "TELEMATICS_AGGREGATIONS/SAGA/FETCH_AGGREGATED_DRIVES";
export const SET_OPENED_DRIVER_ROWS =
  "TELEMATICS_AGGREGATIONS/SET_OPENED_DRIVER_ROWS";
export const SET_BULK_EDIT_MODE = "TELEMATICS_AGGREGATIONS/SET_BULK_EDIT_MODE";
export const SET_RIDES_STATUS_UPDATE = "SET_RIDES_STATUS_UPDATE";
